import { Component } from '@angular/core';
import { SessionStorageService } from '../../services/session-storage.service';
import { SessionStorage } from '../../services/constant.service';
declare function segmentModificationRedirection(url:string): any;

@Component({
  selector: 'app-failure',
  imports: [],
  templateUrl: './failure.component.html',
  styleUrl: './failure.component.less'
})
export class FailureComponent {

  constructor(

        private sessionStorageService : SessionStorageService
    ) {
        
    }
  ngOnInit(){
    let subSource = this.sessionStorageService.getItem(SessionStorage.subSource)?.toUpperCase() ||'';
    if(subSource == 'FLUTTER_ANDROID' || subSource == 'FLUTTER_IOS'){
            setTimeout(() => {
            segmentModificationRedirection(window.location.href);
          }, 3000);  
        }else{
            setTimeout(() => {
           const returnURL = this.sessionStorageService.getItem(SessionStorage.returnURL)
            if(returnURL)
           { window.location.href = returnURL }
        else {
        }
          }, 2000);  
        }
      
      }

}
